import { Image, AspectRatio, CSSObject } from '@chakra-ui/react'

import ImageSrc from '@/svg/services/decor-1.svg'

interface Props {
  sx?: CSSObject
}

function Decor1({ sx }: Props): React.ReactElement {
  return (
    <AspectRatio
      ratio={217 / 43}
      sx={{
        zIndex: -1,
        top: {
          base: 8,
          xl: 16,
        },
        right: {
          base: 8,
          xl: 16,
        },
        display: {
          base: 'none',
          lg: 'block',
        },
        maxW: '217px',
        w: '10%',
        position: 'absolute',
        overflow: 'visible',
        ...sx,
      }}
    >
      <Image
        src={ImageSrc}
        alt="Decoration 1"
        sx={{ objectFit: 'contain !important' }}
      />
    </AspectRatio>
  )
}
export default Decor1
